import type {
  RestaurantToShow,
  WithNextDiscountDayAvailable,
} from '@discover-data/stores/restaurant/model/types';
import getDiscountValues from '@discover-lib/discount/getDiscountValues';
import getDiscountLabel from '@discover-lib/discount/getDiscountLabel';
import calculateServiceFee from '@discover-lib/calculateServiceFee';
import { currencyFormat } from '@discover-lib/dataFormats';
import extractNumberFromString from '@discover-lib/extractNumberFromString';
import globalState from '@/lib/globalState';
import getSessionBookingPrice from '@discover-components/availability/discount/section/getSessionBookingPrice';

export default function getRestaurantChips(
  restaurant: Pick<
    RestaurantToShow,
    | 'bookingPricesBySession'
    | 'discountAvailability'
    | 'potentialPoints'
    | 'dinerOptions'
    | 'minDiners'
    | 'maxDiners'
  > &
    WithNextDiscountDayAvailable,
  session: SessionType,
  people: number,
  // In the row layout the discount badge moves into the card-header chips.
  isRowLayout = false
) {
  const bookingPrice = getSessionBookingPrice(
    'rrp',
    restaurant.bookingPricesBySession,
    session,
    people
  );
  const discount = getDiscountValues(restaurant.discountAvailability)[0];
  const fee = calculateServiceFee(extractNumberFromString(bookingPrice), discount);
  const points =
    restaurant.potentialPoints?.find((entry) => entry?.key === 'FIRST_TABLE')?.value || undefined;

  return {
    fee: fee ? currencyFormat(fee, '', globalState.siteConfig) : undefined,
    feeAmount: fee,
    people,
    points,
    discountLabel: isRowLayout && discount ? `${getDiscountLabel(discount)} off` : undefined,
  };
}
